import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';
import Anime from '../../components/Anime/Anime';

// Components
import ProgressiveImage from '../../components/ProgressiveImage/ProgressiveImage';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';

// Images
class PageNotFound extends Component {
    render () {
        return (
            <div className="app-section mb">
                    <MetaTags>
                        <title>Page not found!</title>
                        <meta name="description" content="Error 404 page doesn\'t exist!" />
                    </MetaTags>

                <div className="container">

                    <ContentHeader title="Upsss... Page not found!" subTitle="We looked everywhere. Looks like this page is missing." classes="" />

                    <div className="row">
                        <Anime type="fade-up" delay="3" duration="3">
                            <ProgressiveImage 
                                src="https://rascalsthemes.com/images/404.png"
                                srcLow=""
                                width="521"
                                height="318"
                                maxWidth="521px"
                                bgColor="transparent"
                                alt="Page does not exist!"
                            />
                        </Anime>
                    </div>

                </div>
            </div>
        );
    }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./src/pages/PageNotFound/PageNotFound.js